
/* injects from baggage-loader */

'use strict';

export default class ProductGroupController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}
